import { PropsWithChildren } from 'react';

import { useFIPSMode } from '@/react/portainer/settings/queries/useFIPSMode';

import { Alert } from '@@/Alert';

interface Props {
  docsUrl?: string;
  docsLabel?: string;
}

/**
 * Warns that FIPS compliance of a third-party endpoint is the operator's
 * responsibility. Use it for integrations where the provider exposes no
 * FIPS-specific endpoint for Portainer to select or validate.
 *
 * Renders nothing outside FIPS mode, so callers do not need their own guard.
 */
export function FipsWarning({
  docsUrl,
  docsLabel,
  children,
}: PropsWithChildren<Props>) {
  const isFipsEnabled = useFIPSMode();

  if (!isFipsEnabled) {
    return null;
  }

  return (
    <Alert color="warn">
      When running in FIPS mode, {children}
      {docsUrl ? (
        <>
          {' '}
          <a
            href={docsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="underline"
          >
            Consult {docsLabel} documentation
          </a>{' '}
          for FIPS compliance information.
        </>
      ) : null}
    </Alert>
  );
}
